<template>
  <div class="formulario-guardar-cita" data-app>
    <titulo-seccion titulo="AGENDAR CITA"></titulo-seccion>
    <div class="container container-agenda">
      <form @submit="GuardarCita">
        <div class="row-cols-12 w-100 ">
          <p class="parrafo-instrucciones parrafo-agenda mt-2">
            Ingresa la fecha, hora y lugar (link) en relación a la llamada con
            el prospecto. Considera que el prospecto recibirá un correo
            electrónico notificando la fecha, hora y lugar o enlace.
          </p>
        </div>
        <div class="row row-cols-lg-12">
          <div class="col-lg-12">
            <label class="form-label label-formulario-solicitud label-agenda"
              >Fecha</label
            >
            <input-fecha
              :requerido="true"
              idioma="es-MX"
              v-model="DatosCita.Fecha"
              :fechaMinima="new Date().toISOString()"
            ></input-fecha>
          </div>
        </div>
        <div class="row row-cols-lg-12 mt-2">
          <div class="form-group col-lg-6 col-6">
            <label class="form-label label-formulario-solicitud label-agenda"
              >Hora de inicio</label
            >
            <input-hora
              ref="inputHoraInicio"
              :deshabilitado="false"
              :requerido="true"
              :horaMinima="HoraInicioMinima"
              v-model="DatosCita.HoraInicio"
            ></input-hora>
          </div>
          <div class="form-group col-lg-6 col-6">
            <label class="form-label label-formulario-solicitud label-agenda"
              >Hora de fin</label
            >
            <input-hora
              ref="inputHoraFin"
              :deshabilitado="HoraFinDeshabilitado"
              :requerido="true"
              :horaMinima="HoraFinMinima"
              v-model="DatosCita.HoraFin"
            ></input-hora>
          </div>
        </div>
        <div class="row row-cols-lg-12 mt-3">
          <div class="col-lg-12">
            <label class="form-label label-formulario-solicitud label-agenda"
              >Ubicación o Enlace (Videoconferencia o videollamada):</label
            >
            <textarea
              class="form-control campo-basico campo-agenda-ubicacion"
              rows="3"
              v-model="DatosCita.Ubicacion"
            ></textarea>
          </div>
        </div>
        <div class="row col-lg-12 d-flex justify-content-center m-0 mt-4 p-0">
          <div class="col-12 p-0">
            <button
              v-if="loadingRegistroCita"
              disabled
              class="btn w-100 boton-primario boton-agenda mb-3"
            >
              <v-progress-circular
                indeterminate
                size="30"
                color="white"
              ></v-progress-circular>
            </button>
            <button
              v-else
              type="submit"
              class="btn w-100 boton-primario boton-agenda mb-3"
            >
              Guardar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="js">

import axios from "axios";
import servicios from '../../../servicios/service.js';
//Componentes
import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import InputFecha from "../components/InputFecha.vue"
import InputHora from "../components/InputHora.vue";
//Mixins
import mixinRegistroEventos from "../Mixins/MixinRegistroEventos";

//Variables
var rutaGuardarCita = "/api/Master/Cita/GuardarCita";

export default {
  name: "RegistroCita",
  mixins: [mixinRegistroEventos],
  components: {
    TituloSeccion,
    InputFecha,
    InputHora
  },
  mounted(){
    const d = new Date();
    this.HoraInicioMinima =  d.getHours() + ":" + d.getMinutes();
  },
  data() {
    return {
      DatosCita: {
        MasterId: 1,
        ProspectoId:  this.$store.getters.prospectoId,
        Fecha:null,
        HoraInicio:null,
        HoraFin:null,
        MotivoId: 0,
        Ubicacion: null,
        CaminoId:null
      },
      loadingRegistroCita:false,
      HoraInicioMinima:null,
      HoraFinMinima:null,
      HoraFinDeshabilitado:true,
    };
  },
  methods: {
    CamposLlenos(){
      if(this.DatosCita.Fecha == null || this.DatosCita.Fecha === "") return false;
      if(this.DatosCita.HoraInicio == null || this.DatosCita.HoraInicio === "") return false;
      if(this.DatosCita.HoraFin == null || this.DatosCita.HoraFin === "") return false;
      if(this.DatosCita.Ubicacion == null || this.DatosCita.Ubicacion === "") return false;
      return true;
    },
    GuardarCita : function(e) {
      e.preventDefault();
      if(this.CamposLlenos()) {
        const fechaInicio = servicios.DarFormatoFecha(new Date(this.DatosCita.Fecha + " " + this.DatosCita.HoraInicio));
        const fechaFin = servicios.DarFormatoFecha(new Date(this.DatosCita.Fecha + " " + this.DatosCita.HoraFin));
        const Cita = {
          "MasterId": this.DatosCita.MasterId,
          "ProspectoId": this.DatosCita.ProspectoId,
          "FechaInicio" : fechaInicio,
          "FechaFin" : fechaFin,
          "MotivoCitaId": this.DatosCita.MotivoId,
          "CaminoId": this.DatosCita.CaminoId,
          "Ubicacion": this.DatosCita.Ubicacion
        }
        this.VerificarFechaEvento(fechaInicio, Cita);
      } else {
        this.AlertaEmbajadores("Por favor llene todos los campos necesarios para agendar la cita.", true);
      }
    },
    RegistroEvento: function(Cita) {
      this.loadingRegistroCita = true;
      axios.post(rutaGuardarCita, Cita)
        .then(resp => {
          this.loadingRegistroCita = false;
          if (resp.data.estado === 0) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
            // axios.defaults.headers.common["Authorization"] =
            //   "Bearer " + this.token;
            this.$router.push({
              name: 'AdministracionDeProspectos'
            });
          } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
  },
  watch :{
    'DatosCita.Fecha' : function(value) {
      this.DatosCita.HoraInicio = null;
      this.DatosCita.HoraFin = null;
      this.HoraFinDeshabilitado = true;
      this.$refs.inputHoraInicio.LimpiarTexto();
      this.$refs.inputHoraFin.LimpiarTexto();


      var fechaElegida = new Date(value);
      var hoy = new Date();
      fechaElegida.setDate(fechaElegida.getDate() + 1);
      var fechaElegidaFormato = fechaElegida.toString().substring(4,15);
      if(fechaElegidaFormato != hoy.toString().substring(4,15))
        this.HoraInicioMinima = null;
      else
        this.HoraInicioMinima = hoy.getHours() + ":" + hoy.getMinutes();
    },
    'DatosCita.HoraInicio': function (value) {
      if(value != null){
        this.HoraFinDeshabilitado = false;
        this.HoraFinMinima = value;
      }
    },
    'DatosCita.HoraFin': function (value) {
      if (value === this.DatosCita.HoraInicio) {
        this.AlertaEmbajadores("La hora final debe ser mayor a la hora inicial", true);
        this.DatosCita.HoraFin = null;
        this.$refs.inputHoraFin.LimpiarTexto();
      }
  },
  }
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";
.formulario-guardar-cita {
  background-color: #ffffff;
  flex-grow: 1;
}
</style>
